
import { defineComponent } from 'vue';
import Heading from '@/components/atoms/Heading.vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'ScheduleBox',
  components: {
    Heading,
  },
  props: {
    title: {
      type: String,
      require: true,
    },
    day: {
      type: Number,
    },
    time: {
      type: String,
    },
    place: {
      type: String,
    },
    id: {
      type: String,
    },
  },
  setup(props) {
    const hash = props.id ? `#${props.id}` : '';
    const router = useRouter();
    const jumpPage = () => {
      router.push({ path: '/program', hash: hash });
    };
    return {
      hash,
      jumpPage,
    };
  },
});
